<template>
  <IQOS required :title="'iiko'">
      <BaseButton variant="secondary" color="v1-grey-10" size="md" @click="importMenu" class="mt-16 w-100">
          {{ $t('integrations.iiko_import.menu_btn') }}
      </BaseButton>

      <BaseButton variant="secondary" color="v1-grey-10" size="md" @click="import_workers_confirm = true" class="mt-8 w-100">
           {{ $t('integrations.iiko_import.workers_btn') }}
      </BaseButton>

      <BaseButton variant="secondary" color="v1-grey-10" size="md" @click="import_tables_confirm = true" class="mt-8 w-100">
          {{ $t('integrations.iiko_import.tables_btn') }}
      </BaseButton>

      <InfoModal 
        @close="import_menu_modal = false"
        v-if="import_menu_modal">
         {{ $t('integrations.iiko_import.menu_sent') }}
      </InfoModal>

      <DangerConfirmModal
        @confirm="importWorkers"
        @cancel="import_workers_confirm = false"
        v-if="import_workers_confirm">
     {{ $t('integrations.iiko_import.workers_btn') }}
      </DangerConfirmModal>

      <InfoModal 
        @close="imported_workers_modal = false"
        v-if="imported_workers_modal">
         {{ $t('integrations.iiko_import.workers_sent') }}
      </InfoModal>

      <DangerConfirmModal
        @confirm="importTables"
        @cancel="import_tables_confirm = false"
        v-if="import_tables_confirm">
         {{ $t('integrations.iiko_import.tables_confirm') }}</DangerConfirmModal>

      <InfoModal 
        @close="imported_tables_modal = false"
        v-if="imported_tables_modal">
         {{ $t('integrations.iiko_import.tables_sent') }}
      </InfoModal>
  </IQOS>
</template>

<script>
import InfoModal from "@/components/modals/InfoModal.vue"

import IikoAPI from '@/api/iiko'

export default {
    data() {
        return {
            import_menu_modal: false,
            import_workers_confirm: false,
            imported_workers_modal: false,
            import_tables_confirm: false,
            imported_tables_modal: false
        }
    },
    methods: {
        importMenu() {
            IikoAPI.importMenu(this.$store.state.cafe._id).then(data => {
                this.import_menu_modal = true;
            }).catch(error => {
                alert(error);
            });
        },
        importWorkers() {
            this.import_workers_confirm = false;
            
            IikoAPI.importWorkers(this.$store.state.cafe._id).then(data => {
                this.imported_workers_modal = true;
            }).catch(error => {
                alert(error);
            });
        },
        importTables() {
            this.import_tables_confirm = false;
            
            IikoAPI.importTables(this.$store.state.cafe._id).then(data => {
                this.imported_tables_modal = true;
            }).catch(error => {
                alert(error);
            });
        }
    },
    components: {
        InfoModal,
    }
}
</script>

<style>

</style>